import { OrgSdk } from 'lib-klab-sdks';
import { Option } from '../../../domain/models/shared/option.model';

export function mapSDKDepartmentsToOptions(
    res: OrgSdk.PagedDepartmentResponse
): Option[] {

    return (res.content ?? [])
        .map(d => ({
            id: String(d.departmentId),
            name: String(d.name ?? '').trim(),
        }))
        .filter(o => !!o.id && !!o.name);
}
